import React from "react";

const RSEContent = () => {
  return (
    <>
      <main id="body-content">
        {/* Hero Section */}
        <section className="bg-white wide-tb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div
                className="col-lg-10 text-center wow fadeInDown"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <h1 className="heading-main">
                  <span>Notre Engagement</span>
                  Responsabilité Sociétale & Environnementale
                </h1>
                <p className="lead txt-blue mb-4">
                  Chez <strong>LOG2TRANS SARL</strong>, nous intégrons dans
                  notre fonctionnement quotidien les préoccupations sociales,
                  environnementales et économiques, en harmonie avec les
                  orientations du Cameroun et du monde entier.
                </p>
                <div className="rse-mission-box">
                  <h4 className="h4-md txt-orange mb-3">Notre ambition</h4>
                  <p>
                    Conjuguer performance économique, sociale et
                    environnementale, pour bâtir une entreprise durable,
                    responsable et respectueuse de l'humain.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Protection des Enfants */}
        <section className="wide-tb-100 bg-light-gray">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-lg-6 wow fadeInLeft"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <div className="rse-icon-container">
                  <i className="icofont-baby"></i>
                </div>
              </div>
              <div
                className="col-lg-6 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="rse-content-box">
                  <h2 className="h2-md mb-4 txt-blue fw-7">
                    <i className="icofont-baby mr-3 txt-orange"></i>
                    Protection des Droits des Enfants
                  </h2>
                  <p className="mb-4">
                    Nous adhérons pleinement aux initiatives internationales
                    visant à :
                  </p>
                  <ul className="list-unstyled icons-listing theme-orange mb-0">
                    <li>
                      <i className="icofont-check"></i>Promouvoir le droit à la
                      scolarisation et aux soins de santé pour tous les enfants.
                    </li>
                    <li>
                      <i className="icofont-check"></i>Dénoncer les abus, le
                      travail des enfants et l'exploitation sous toutes ses
                      formes.
                    </li>
                    <li>
                      <i className="icofont-check"></i>Encourager les parents à
                      renforcer leur rôle éducatif et à limiter l'exposition des
                      enfants aux écrans.
                    </li>
                  </ul>
                  <div className="rse-highlight mt-4">
                    <p className="mb-0">
                      <strong>
                        Chez LOG2TRANS, la protection de l'enfance est une
                        priorité éthique.
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Lutte contre la Corruption */}
        <section className="wide-tb-100 bg-white">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-lg-6 order-lg-2 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <div className="rse-icon-container">
                  <i className="icofont-law-order"></i>
                </div>
              </div>
              <div
                className="col-lg-6 order-lg-1 wow fadeInLeft"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="rse-content-box">
                  <h2 className="h2-md mb-4 txt-blue fw-7">
                    <i className="icofont-law-order mr-3 txt-orange"></i>
                    Lutte contre la Corruption
                  </h2>
                  <p className="mb-3">
                    La corruption, sous toutes ses formes, est strictement
                    proscrite dans nos procédures internes.
                  </p>
                  <ul className="list-unstyled icons-listing theme-orange mb-0">
                    <li>
                      <i className="icofont-check"></i>Nos collaborateurs,
                      clients et fournisseurs sont sensibilisés à respecter la
                      charte éthique de l'entreprise.
                    </li>
                    <li>
                      <i className="icofont-check"></i>Aucune démarche
                      administrative, publique ou privée, ne doit faire l'objet
                      d'un acte de corruption.
                    </li>
                  </ul>
                  <div className="rse-highlight mt-4">
                    <p className="mb-0">
                      <strong>
                        Nous croyons à une performance fondée sur l'intégrité et
                        la transparence.
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Égalité de Genre */}
        <section className="wide-tb-100 bg-light-gray">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-lg-6 wow fadeInLeft"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <div className="rse-icon-container">
                  <i className="icofont-users-alt-4"></i>
                </div>
              </div>
              <div
                className="col-lg-6 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="rse-content-box">
                  <h2 className="h2-md mb-4 txt-blue fw-7">
                    <i className="icofont-users-alt-4 mr-3 txt-orange"></i>
                    Égalité de Genre
                  </h2>
                  <p className="mb-4">
                    LOG2TRANS place la promotion des droits de la femme et
                    l'égalité des genres au cœur de son fonctionnement :
                  </p>
                  <ul className="list-unstyled icons-listing theme-orange mb-0">
                    <li>
                      <i className="icofont-check"></i>Nos processus de
                      recrutement garantissent une égalité des chances.
                    </li>
                    <li>
                      <i className="icofont-check"></i>Nos communications
                      internes relaient activement les initiatives
                      internationales en faveur de la femme et de la jeune
                      fille.
                    </li>
                  </ul>
                  <div className="rse-highlight mt-4">
                    <p className="mb-0">
                      <strong>
                        Parce qu'une équipe équilibrée, c'est une entreprise
                        plus forte.
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Lutte contre la Drogue */}
        <section className="wide-tb-100 bg-white">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-lg-6 order-lg-2 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <div className="rse-icon-container">
                  <i className="icofont-ban"></i>
                </div>
              </div>
              <div
                className="col-lg-6 order-lg-1 wow fadeInLeft"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="rse-content-box">
                  <h2 className="h2-md mb-4 txt-blue fw-7">
                    <i className="icofont-ban mr-3 txt-orange"></i>
                    Lutte contre la Drogue
                  </h2>
                  <p className="mb-4">
                    Nous menons une politique de prévention et de
                    sensibilisation contre la consommation de drogues et de
                    stupéfiants :
                  </p>
                  <ul className="list-unstyled icons-listing theme-orange mb-0">
                    <li>
                      <i className="icofont-check"></i>Formation du personnel
                      sur les risques liés à la consommation.
                    </li>
                    <li>
                      <i className="icofont-check"></i>Sensibilisation des
                      parents pour prévenir la drogue en milieu scolaire.
                    </li>
                    <li>
                      <i className="icofont-check"></i>Mise en garde contre le
                      tabac, considéré comme un facteur de risque pour la
                      jeunesse.
                    </li>
                  </ul>
                  <div className="rse-highlight mt-4">
                    <p className="mb-0">
                      <strong>
                        La santé et la sécurité de nos collaborateurs et de
                        leurs familles sont essentielles à notre mission.
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Protection de l'Environnement */}
        <section className="wide-tb-100 bg-light-gray">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-lg-6 wow fadeInLeft"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <div className="rse-icon-container">
                  <i className="icofont-tree-alt"></i>
                </div>
              </div>
              <div
                className="col-lg-6 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="rse-content-box">
                  <h2 className="h2-md mb-4 txt-blue fw-7">
                    <i className="icofont-tree-alt mr-3 txt-orange"></i>
                    Protection de l'Environnement
                  </h2>
                  <p className="mb-4">
                    Acteur engagé pour un monde plus propre, LOG2TRANS met en
                    œuvre plusieurs actions concrètes :
                  </p>
                  <ul className="list-unstyled icons-listing theme-orange mb-0">
                    <li>
                      <i className="icofont-check"></i>Utilisation de carburants
                      certifiés conformes aux normes environnementales.
                    </li>
                    <li>
                      <i className="icofont-check"></i>Contrôle régulier des
                      moteurs pour réduire les émissions de gaz à effet de
                      serre.
                    </li>
                    <li>
                      <i className="icofont-check"></i>Sensibilisation du
                      personnel à la gestion écologique des déchets
                      administratifs.
                    </li>
                  </ul>
                  <div className="rse-highlight mt-4">
                    <p className="mb-0">
                      <strong>
                        Ensemble, nous roulons vers un avenir plus vert.
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="wide-tb-80 bg-scroll bg-img-6 pos-rel callout-style-1">
          <div className="bg-overlay blue opacity-80"></div>
          <div className="container">
            <div
              className="row align-items-center text-center"
              style={{ position: "relative", zIndex: "999" }}
            >
              <div className="col-12">
                <h3 className="h3-xl txt-white mb-4">
                  Engagés pour un avenir responsable
                </h3>
                <p className="txt-white mb-4">
                  Nos engagements RSE ne sont pas de simples déclarations, mais
                  des actions concrètes au quotidien.
                </p>
                <a href="/contact" className="btn btn-theme bg-orange">
                  Contactez-nous <i className="icofont-rounded-right"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default RSEContent;
